import Swiper from "swiper";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper/core";
import { register } from "@shopify/theme-sections";

register("info_module", {
  onLoad() {
    SwiperCore.use([Navigation, Pagination, Autoplay]);
    var infoTitle = new Swiper(".swiper-container-info-title", {
      spaceBetween: 1,
      slidesPerView: 1,
      watchSlidesVisibility: false,
      watchSlidesProgress: true,
      allowTouchMove: false,
      loop: true,
      pagination: {
        el: ".swiper-pagination-info-title",
      },
      effect: "fade",
      navigation: {
        nextEl: ".info-button-next",
        prevEl: ".info-button-prev",
      },
    });

    var infoCarousel = new Swiper(".swiper-container-info", {
      loop: true,
      resistance: true,
      resistanceRatio: 0,
      pagination: {
        el: ".swiper-pagination-info",
        clickable: true,
      },
      thumbs: {
        swiper: infoTitle,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });

    infoTitle.on("slideChange", function () {
      infoCarousel.slideTo(this.activeIndex);
    });

    infoCarousel.on("slideChange", function () {
      infoTitle.slideTo(this.activeIndex);
    });
  },
});
